import { NAME } from './constants';

export const FETCH_CONTACTS = `${NAME}/FETCH_CONTACTS`;
export const FETCH_CONTACTS_FAILURE = `${NAME}/FETCH_CONTACTS_FAILURE`;
export const FETCH_CONTACTS_SUCCESS = `${NAME}/FETCH_CONTACTS_SUCCESS`;

export const FETCH_GEOCODE = `${NAME}/FETCH_GEOCODE`;
export const FETCH_GEOCODE_ERROR = `${NAME}/FETCH_GEOCODE_ERROR`;
export const FETCH_GEOCODE_SUCCESS = `${NAME}/FETCH_GEOCODE_SUCCESS`;

export const FETCH_GEOCODE_POINT = `${NAME}/FETCH_GEOCODE_POINT`;
export const FETCH_GEOCODE_POINT_FAILURE = `${NAME}/FETCH_GEOCODE_POINT_FAILURE`;
export const FETCH_GEOCODE_POINT_SUCCESS = `${NAME}/FETCH_GEOCODE_POINT_SUCCESS`;

export const INITIALIZE_VALUES = `${NAME}/INITIALIZE_VALUES`;

export const RESET = `${NAME}/RESET`;
export const RESET_FORM = `${NAME}/RESET_FORM`;

export const SAVE_PROJECT = `${NAME}/SAVE_PROJECT`;
export const SAVE_PROJECT_FAILURE = `${NAME}/SAVE_PROJECT_FAILURE`;
export const SAVE_PROJECT_SUCCESS = `${NAME}/SAVE_PROJECT_SUCCESS`;

export const SET_IS_NEW_RECORD = `${NAME}/SET_IS_NEW_RECORD`;

export const SET_IS_OPEN_MODAL = `${NAME}/SET_IS_OPEN_MODAL`;

export const SET_SHOW_GEOCODE_RESULTS = `${NAME}/SET_SHOW_GEOCODE_RESULTS`;
